import { render, staticRenderFns } from "./ImageView.vue?vue&type=template&id=d524209a&scoped=true&"
import script from "./ImageView.vue?vue&type=script&lang=js&"
export * from "./ImageView.vue?vue&type=script&lang=js&"
import style0 from "./ImageView.vue?vue&type=style&index=0&id=d524209a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d524209a",
  null
  
)

export default component.exports